<template>
    <div class="setting-content--section">
        <div class="d-flex mb-4 w-100 justify-content-end flex-wrap" style="gap: 1rem;">
          <CreateProduct data-analytics-click="Products: create top settings page" :createdCallback="retrieveGroupsAndProducts">
            <GekkoButton
              :text="$gettext('Add product')"
              icon="fa-solid fa-plus"
            />
          </CreateProduct>
          <CreateProductGroup data-analytics-click="Products: create group top settings page" :createdCallback="retrieveGroupsAndProducts"></CreateProductGroup>
          <GekkoButton 
            @click="getReportUrl()" 
            :text="$gettext('Report')" 
            icon="fa-solid fa-chart-simple"
            variant="outline-primary"
          />
        </div>
        <div class="table-responsive gk-table gk-table--responsive gk-table--striped gk-table--headed light-bg-head gk-table--hover">
          <table class="table b-table">
              <thead>
                <th class="mw-130"></th>
                <th v-translate>Description</th>
                <th v-translate class="text-right">Amount ex. vat</th>
                <th v-translate class="text-right">Tax rate</th>
                <th v-translate class="text-right">Amount inc. vat</th>
                <th colspan="2"></th>
              </thead>
              <tbody v-if="items.length==0">
                <tr>
                  <td colspan="6">
                    <p class="text-warning text-center">
                      <span v-translate>You have no products defined for this company.</span>
                      <CreateProduct :createdCallback="retrieveGroupsAndProducts">
                        <GekkoButton
                          :text="$gettext('Add product')"
                          icon="fa-solid fa-plus"
                        />
                      </CreateProduct>
                      <span v-translate>or</span>
                      <a target="_blank" href='https://gekko.groovehq.com/knowledge_base/topics/producten-toevoegen-aan-je-factuur' v-translate>read more</a>
                    </p>
                  </td>
                </tr>
              </tbody>
              <tbody v-for="itemGroup in groups" v-show="itemGroup.products && itemGroup.products.length > 0" :key="itemGroup.name">
                  <tr>
                    <td style="border-top: 4px #DDDDDD solid;" colspan="3">
                      <h3 style="display: inline-block;">{{ itemGroup.name }}</h3>
                    </td>
                    <td colspan="5" style="border-top: 4px #DDDDDD solid;">
                      <div v-if="itemGroup.id" style="float: right;">
                        <CreateProductGroup data-analytics-click="Products: edit group" :initialGroup="itemGroup" :createdCallback="retrieveGroupsAndProducts"></CreateProductGroup>
                        <GekkoButton 
                          @click="deleteGroup(itemGroup.id)"
                          icon="fa-solid fa-trash-can"
                          class="text-danger"
                          variant="link"
                          size="sm"
                        />
                      </div>
                    </td>
                  </tr>

                  <tr v-for="item in itemGroup.products" :key="item.id" :class="item.archived ? 'row-archived' : ''">
                      <td></td>
                      <td>{{ item.description }}</td>
                      <td class="text-right">&euro;{{ item.amount }}</td>
                      <td class="text-right">
                          <div v-if="!item.vat_exempt">{{ item.tax_rate }}%</div>
                          <div v-if="item.vat_exempt" v-translate> VAT Exempt </div>
                      </td>
                      <td class="text-right">&euro;{{ item.total_inc_vat }}</td>
                      <td class="text-right">
                          <ProductArchive :data_object="item"></ProductArchive>
                      </td>
                      <td class="text-right">


                          <div role="presentation" class="dropdown float-right" >
                            <b-dropdown id="dropdown-1" variant="link" right
                            toggle-class="text-decoration-none" no-caret :disabled="item.archived" class="ui-dashboard-menu-dropdown">
                              <template v-slot:button-content>
                                <font-awesome-icon icon="fa-solid fa-ellipsis-vertical" />
                              </template>
                              <CreateProduct :initialValues="item" :createdCallback="retrieveGroupsAndProducts">
                                  <b-dropdown-item>
                                    <font-awesome-icon icon="fa-solid fa-pen-to-square" /> {{ $gettext('Edit') }}
                                  </b-dropdown-item>
                              </CreateProduct>
                              <b-dropdown-item>
                                <a 
                                  href="" 
                                  confirm-delete 
                                  on-success="destroy(item)" 
                                  title="$gettext('Delete product')"
                                  class="text-danger"
                                >
                                  <font-awesome-icon icon="fa-solid fa-trash-can" /> <span v-translate>Delete</span>
                                </a>

                                <!-- <GekkoButton 
                                  @click="addInvestmentItem()" 
                                  confirm-delete 
                                  on-success="destroy(item)" 
                                  :text="$gettext('Delete product')" 
                                  icon="fa-solid fa-trash-can"
                                  class="p-0 text-danger"
                                  variant="link"
                                /> -->

                              </b-dropdown-item>
                            </b-dropdown>
                          </div>
                      </td>
                  </tr>
                  <tr v-if="itemGroup.id" >
                    <td colspan="7" style="text-align: center;border-bottom: 40px #FFF solid;">
                      <CreateProduct data-analytics-click="Products: create with no group from settings" :initialGroup="itemGroup.id" :createdCallback="retrieveGroupsAndProducts">
                        <GekkoButton
                          :text="$gettext('Add product')"
                          icon="fa-solid fa-plus"
                          variant="link"
                          class="text-info"
                        />
                      </CreateProduct>
                    </td>
                  </tr>
                  <tr v-else>
                    <td colspan="7" style="text-align: center;border-bottom: 40px #FFF solid;">
                      <CreateProduct data-analytics-click="Products: create with group from settings" :initialGroup="itemGroup.id" :createdCallback="retrieveGroupsAndProducts">
                        <GekkoButton
                          :text="$gettext('Add product')"
                          icon="fa-solid fa-plus"
                          variant="link"
                          class="text-info"
                        />
                      </CreateProduct>
                    </td>
                  </tr>
              </tbody>
          </table>
        </div>
    </div>
</template>

<script>
import ProductService from "@/store/services/product.service.js";
import ProductGroupService from "@/store/services/productgroup.service.js";
import CreateProductGroup from "@/components/products/CreateProductGroup";
import CreateProduct from "@/components/products/CreateProduct";
import ProductArchive from "@/components/products/ProductArchive";
import GekkoButton from "@/components/GekkoButton";

// mixins
import settingsPageSetup from "@/mixins/settingsPageSetup";

//TODO: somehow import these styles here...
//<link rel="stylesheet" href="{{ STATIC_URL }}less/settings_costtypes.less" type="text/less">
//<link rel="stylesheet" href="{{ STATIC_URL }}products/products-settings/product-list.style.less" type="text/less">
//<link rel="stylesheet" href="{{ STATIC_URL }}js/modules/gekko/vat-input-picker/vat-input.style.less" type="text/less">


export default {
    name: "ProductList",
    components: {
      CreateProductGroup,
      CreateProduct,
      ProductArchive,
      GekkoButton
    },
    mixins: [settingsPageSetup],
    data(){
      return {
        pageSettings: {
          title: this.$gettext("My products"),
          showCompanyPicker: true
        },
        items: [],
        groups: [],
      }
    },
    created() {
      this.retrieveGroupsAndProducts();
    },
    methods: {
      retrieveGroupsAndProducts (){
        var vm = this;
        // Retrieve groups, then products.
        ProductGroupService.list({company_profile: window.company_id}).then(function (response) {
          this.groups = response.data
          this.groups = this.groups.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
          this.groups.unshift({id: null, name: vm.$gettext('No Group')})
          this.retrieveProducts()
        }.bind(this))
      },
      retrieveProducts () {
        ProductService.list({company_profile: window.company_id}).then(function(response){
          this.items = response.data.sort((a,b) => (a.group > b.group) ? 1 : ((b.group > a.group) ? -1 : 0))
          for (var group of this.groups) {
            group['products'] = this.items.filter(item => { return item.group === group.id })
          }
        }.bind(this))
      },
      deleteGroup(pk){
          ProductGroupService.destroy(pk).then(function () {
              this.$mixpanel.track('Product group: delete');
              this.$forceUpdate();
          })
      },
      destroy(item){
          ProductService.destroy(item.id).then(function () {
              // $filter('removeFromArray')(ctrl.items, item);
          });
      },
      getReportUrl(){
          window.location.href = window.Urls['reports:home']()+'#/products';
      },
    },
    computed: {

    }
};
</script>
<style scoped>
.mw-130{
    min-width: 130px;
}
.row-archived{
    color: gray;
}
.row-archived:hover{
    color: gray !important;
}
</style>
